import React, { useState } from "react";
import { observer } from "mobx-react";
import { Button } from "primereact/button";
import ScenarioStore from "../../store/ScenarioStore";
import ScenarioCreationDialog from "./ScenarioCreationDialog";
import { Scenario } from "../../api/firebase/types/scenario.types";
import ConfirmDialog from "../../components/dialogs/ConfirmDialog";
import InfoDialog from "../../components/dialogs/InfoDialog";

export type ScenarioToolbarProps = {
  scenariosToDelete: Scenario[] | undefined;
  onDelete: () => void;
  showLoader: React.Dispatch<React.SetStateAction<boolean>>;
};

const ScenarioToolbarRightElements: React.FC<ScenarioToolbarProps> = (
  props
) => {
  const [isDialogVisible, setDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [infoDialogVisible, setInfoDialogVisible] = useState(false);

  const deleteScenarios = async () => {
    props.showLoader(true);
    try {
      const deletionSucceeded = await ScenarioStore.deleteScenarios(
        props.scenariosToDelete!.map((scenario) => scenario.id)
      );
      if (!deletionSucceeded) {
        alert("Einige Szenarien konnten nicht entfernt werden");
      }
    } catch (e: any) {
      console.error(e);
      if (e.message === "in-use") setInfoDialogVisible(true);
    }
    props.onDelete();
  };

  const ToolbarRightElements = () => {
    return (
      <>
        <Button
          label="Szenario erstellen"
          icon="pi pi-plus"
          className="p-button-text p-mr-2"
          onClick={() => setDialogVisible(true)}
        />
        <Button
          label="Löschen"
          icon="pi pi-trash"
          className="p-button-text p-button-danger"
          onClick={() => setDeleteDialogVisible(true)}
          disabled={
            !props.scenariosToDelete || props.scenariosToDelete.length === 0
          }
        />
      </>
    );
  };

  return (
    <>
      <ToolbarRightElements />
      <ScenarioCreationDialog
        isDialogVisible={isDialogVisible}
        closeDialog={() => setDialogVisible(false)}
      />
      <InfoDialog
        isVisible={infoDialogVisible}
        onHide={() => setInfoDialogVisible(false)}
        header="Löschen nicht möglich"
        text="Die Szenarien konnten nicht gelöscht werden, da sie noch einer oder
        mehrerer Meldeinstanzen zugewiesen sind."
      />
      <ConfirmDialog
        header="Szenarien entfernen?"
        content="Möchten Sie die ausgewählten Szenarien wirklich entfernen?"
        onHide={() => setDeleteDialogVisible(false)}
        isVisible={deleteDialogVisible}
        onClickYes={deleteScenarios}
      />
    </>
  );
};

export default observer(ScenarioToolbarRightElements);
